import type { ReactNode } from 'react';
import { Icon } from '../icons/index.ts';

export interface MockSidebarProps {
  readonly workspace: string;
  readonly searchLabel: string;
  readonly children: ReactNode;
}

/**
 * Sidebar 232px của mock app — tên workspace, ô tìm kiếm, rồi danh sách do phía gọi truyền vào.
 *
 * Ẩn dưới `lg` cùng lý do với `MockRail`. `w-58` = 232px (58 × 4px).
 *
 * Ô tìm kiếm là hình vẽ, không phải `<input>`: mock là ảnh chụp giao diện, không phải giao diện.
 * Một `<input>` thật ở đây sẽ nhận được focus khi người dùng Tab qua trang và họ gõ vào một ô
 * không làm gì cả.
 */
export function MockSidebar({ workspace, searchLabel, children }: MockSidebarProps) {
  return (
    <div className="hidden w-58 border-r border-ink-100 bg-surface-alt px-3 py-3.5 text-left lg:block">
      <div className="mb-3 flex items-center justify-between">
        <span className="text-body font-bold text-ink-mock-900">{workspace}</span>
        <Icon name="chevrons-up-down" size={14} className="text-ink-400" />
      </div>
      <div className="mb-3.5 flex h-8 items-center gap-[7px] rounded-field border border-ink-100 bg-surface px-2.5 text-caption leading-[normal] text-ink-400">
        <Icon name="search" size={13} />
        <span>{searchLabel}</span>
        <span className="ml-auto font-mono text-nano">⌘K</span>
      </div>
      {children}
    </div>
  );
}
